<style scoped>
.Spacer {
  width: 15px;
  min-width: 15px;
  height: 15px;
  min-height: 15px;
}
</style>

<template>
  <div class="Spacer"></div>
</template>

<script>

// -----

export default {
  props: {},
}
</script>
